import { Component } from '@angular/core';

@Component({
  selector: 'rr-menue',
  standalone: false,
  templateUrl: './menue.component.html',
  styleUrl: './menue.component.scss'
})
export class MenueComponent {

}
